import type { WorkflowTriggerType } from '@repositories/workflowBaseTriggerRepository/workflowBaseTrigger.types';
import type { WorkflowTrigger } from '../workflow.types';

export class WorkflowTriggerModel {
  private readonly _dto: WorkflowTrigger;

  constructor(dto: WorkflowTrigger) {
    this._dto = dto;
  }

  get originDTO(): WorkflowTrigger {
    return this._dto;
  }

  get conditionExpression(): string {
    return this._dto.conditionExpression || '';
  }

  get cronExpression(): string {
    return this._dto.cronExpression || '';
  }

  get cronTimeZone(): string {
    return this._dto.cronTimeZone || '';
  }

  get executionStartTime(): string {
    return this._dto.executionStartTime || '';
  }

  get type(): WorkflowTriggerType {
    return this._dto.type || 'DIRECT_API_TRIGGER';
  }
}
